window.hasOwnProperty = window.hasOwnProperty || Object.prototype.hasOwnProperty;

var eM = {
	//this is the environment helper - it will determine the and locale - removing the tooltips dependancy on the ad manager
	//set the server the script is loaded from via php
	server : "%%server_url%%",
	//set the cdn via php
	cdn : "%%cdn%%",
	//set empty object for holding the vars we need
	cP : {
		localeKey : null,
		locale : null,
		level : null,
		pageType : null,
		pageTypeKey : null,
		localeAbs : null
	},
	//set page types, these are loaded externally for some reason that probably doesn't exist anymore
	pageTypes : null,
	//holder for the locale lookup
	localeLookup : null,
	//reverse lookup - for working backwards
	localeReverseLookup : null,
	//random hook for loading event - now legacy and turned off
	//eventWatch: $("title"),
	//store the current page id
	pageId : null,
	//so we don't look for body every time
	body : $('body'),
	userLang : $("#user_lang").text(),
	userLocaleCode : null,
	//needed for WT
	pathData : document.location.pathname ? ((document.location.pathname.indexOf("/") != 0) ? "/" + document.location.pathname : document.location.pathname) : "/",
	//store touch test result
	touchDevice : null,
	device : null,
	userState : null,
	ud : "undefined",
	//init call
	init : function() {
		var i = this;
		//i.selectLocaleLookup();
		i.localeLookup = i.localeLookupBase.live;

		i.setLocale();
		i.isTouchDevice();
		//add the extra css
		//temp fix so that stage and dev can use the same code
		// if(typeof(ad_dev) == "undefined"){
		//
		// $('head').append('<link rel="stylesheet" href="'+i.server+'/assets/extra.css" type="text/css" />');
		// }
	},
	/*selectLocaleLookup: function(){
	 //we need to switch between live and stage because they're not the same... which makes so much sense...
	 var url = window.location.href;
	 var i = this;
	 //need to consolidate this with the other live/dev/stage checkers at some point, then again, all three are different
	 if (url.search("community.eu.psesc") != -1) {
	 i.localeLookup = i.localeLookupBase.stage;
	 } else {
	 i.localeLookup = i.localeLookupBase.live;
	 }

	 },*/
	/*
	 * since this was done, the forums have had a lot done to them, significantly the pageData object which also contains "type"
	 *
	 */
	getPageType : function(usePageData) {
		// Nic page types :)
		var types = $( '#PDC6-main-container' ).data( 'page-type' );

		if( types )
		{
			types = types.split( ' ' );

			if( types.indexOf( 'home' ) >= 0 )
			{
				return 'home';
			}
		}

		var i = this;
		//to let us keep using eM to get pageData, we'll add the parameter to let it know we want to use pageData
		if((typeof(usePageData) != eM.ud) && (usePageData == true)){
			return pageData.type;
		}

		//due to the way the page is done, we need to look at the url and try and set it from there, or look at the nodes
		if (i.cP.pageType == null) {

			var url = window.location.href;
			var set = false;
			//thread test
			if ((url.search("/td-p/") != -1) || (url.search("/m-p/") != -1)) {
				i.cP.pageTypeKey = 4;

				i.cP.pageType = i.pageTypes[4];
				set = true;

			}
			//board test
			if ((!set) && ((url.search("/bd-p/") != -1) || (url.search("/tkb-p/") != -1))) {
				i.cP.pageTypeKey = 3;

				i.cP.pageType = i.pageTypes[3];
				set = true;

			}
			//are we on the tkb
			if ((!set) && (url.search("/ta-p/") != -1)) {
				i.cP.pageType = i.pageTypes[5];
				set = true;

			}
			//otherwise, we can get where we are from the node - we'll always have the node, so this goes last
			if (!set) {
				var coreNode = i.getCoreNode();
				//then we look up the length in our page types
				var count = coreNode.ancestors.length;
				i.cP.pageTypeKey = count;

				i.cP.pageType = i.pageTypes[count];
			}
		}

		if( i.cP.pageType == undefined )
		{
			i.cP.pageType = 'generic';
		}

		return i.cP.pageType;
	},

	//wrapper to access lithium settings
	getCoreNode : function() {
		var i = this;

		if (i.cP.coreNode == null) {
			i.cP.coreNode = LITHIUM.CommunityJsonObject.CoreNode;
		}
		return i.cP.coreNode;
	},
	setLocale : function() {
		var i = this;
		var u = i.ud;
		//console.log(node_id);
		if (i.cP.locale == null) {
			var cN = i.getCoreNode();
			//console.log(cN);
			var lL = i.localeLookup;
			var lId = null;
			if (lL.hasOwnProperty(cN.id)) {
				i.cP.localeKey = lL[cN.id].v;
				//we want to be able to look into the values to see if we have a specific localeAbs for this locale
				//so we reference this to check in a second
				lId = cN.id;
				if (lL[cN.id].hasOwnProperty("t")) {

					i.cP.tso = lL[cN.id].t;
				}
				i.cP.locale = lL[cN.id].f;
			}
			if (i.cP.locale == null) {
				for (var k in cN.ancestors) {
					var cid = cN.ancestors[k].id;
					//if(lL.hasOwnProperty(cid)){
					if ( typeof (lL.cid) != u) {

						i.cP.localeKey = lL[cid].v;
						lId = cid;

						i.cP.locale = lL[cid].f;
					}

				}
			}
			if (i.cP.locale == null) {
				//if we still don't know, we'll revert to en_GB
				i.cP.localeKey = lL[55].v;
				lId = 55;

				i.cP.locale = lL[55].f;
			}
			/*
			 we look to see if the selected value has an abs value 'a'
			 or just use the video value 'v'

			 */
			if (lId != null) {
				if (lL[lId].hasOwnProperty('a')) {
					i.cP.localeAbs = lL[lId].a;
				} else {
					i.cP.localeAbs = lL[lId].v;

				}
			}
		}

		return i.cP.locale;
	},
	getReverseLocaleLookup : function() {
		var i = this;
		var u = i.ud;
		if (i.localeReverseLookup == null) {
			var lRl = i.localeReverseLookup = {};
			var lL = i.localeLookup;

			for (var k in lL) {
				//console.log(lL[k].v);
				//if(!lL[k].hasOwnProperty('m_i')){
				if ( typeof (lL[k].m_i) == u) {
					var lCode = lL[k].v;
					//if(lL[k].hasOwnProperty('a')){
					if ( typeof (lL[k].a) != u) {

						lCode = lL[k].a;

					}
					lRl[lCode] = k;
				}

			}

		}
		return i.localeReverseLookup;

	},
	getThreadId : function() {
		var t = {}
		t.url = window.location.href;
		t.b = t.url.split("/");
		//sometimes campaigns have wt code attached to them, this sorts that out
		t.c = t.b[7].split("?");
		return t.c[0];

	},
	getPageId : function() {
		var i = this;
		if (i.pageId == null) {
			if (i.getPageType() == 'thread') {
				//we need to get the thread id... somehow - through the medium of dance, or we do this...
				i.pageId = i.getThreadId();

			} else {
				var coreNode = i.getCoreNode();
				i.pageId = coreNode.id;

			}
		}
		return i.pageId;
	},
	isTouchDevice : function() {

		if (this.touchDevice == null) {
			this.touchDevice = !!('ontouchstart' in window);

		}
		return this.touchDevice;

	},
	//no longer used

	/*isLive : function() {
		var i = this;
		if ( typeof (i.liveMode) == 'undefined') {
			i.liveMode = true;
			if (window.location.href.search("eu.playstation.com") == -1) {
				i.liveMode = false;
			}

		}
		return i.liveMode;
	},
	isDev : function() {
		var i = this;
		if ( typeof (i.devMode) == 'undefined') {
			i.devMode = true;
			if (window.location.href.search("communitydev") == -1) {
				i.devMode = false;
			}

		}
		return i.devMode;

	},*/
	getLocale : function() {
		return this.cP.localeKey;
	},
	getLocaleAbs : function() {
		return this.cP.localeAbs;
	},
	getUserLang : function() {
		return this.userLang;
	},
	getUserLocaleCode : function() {
		var i = this;
		var liL = i.localeLookupBase.lithiumLookup;
		if (i.userLocaleCode == null) {
			//we need to reverse lookup the lang
			for (var k in liL) {
				//for oddities

				if (k == i.userLang) {
					i.userLocaleCode = liL[k];
					break;
				}
			}
		}
		return i.userLocaleCode;
	},
	getDevice : function() {
		/*
		 * content devices:
		 * PS3/HD,
		 * PS3/SD,
		 * PSVita,
		 * PS4,
		 * PC,
		 * Tab,
		 * Mob
		 */
		var i = this;
		i.ua = navigator.userAgent;
		if (i.device == null) {
			//for tablet
			var devices = {
				'ps3' : {
					f : 'ckPS3HD'
				},
				'ps3' : {
					f : 'ckPS3SD'
				},
				'PSVita' : {
					f : 'ckPSVita'
				},
				'ps4' : {
					f : 'ckPS4'
				},
				'mobile' : {
					f : 'ckMob'
				}, //must be done before tab
				//'Tab': 	{f: 'ckTab'},
				'pc' : {
					f : 'ckPC'
				},
				'psp' : {
					f : 'ckPSP'
				}
			};
			//console.log(devices);
			//console.log(i.ua);

			//we now iterate through the devices
			for (var k in devices) {
				//console.log('testing: '+k);
				//console.log(i[devices[k].f]());

				if (i[devices[k].f]()) {
					i.device = k;
					break;
				}
			}
		}
		return i.device;

	},
	ckPS3HD : function() {
		if ((/Playstation 3/i.test(this.ua)) && (screen.width == 1920)) {
			return true;
		}
		return false;
	},
	ckPS3SD : function() {
		if ((/Playstation 3/i.test(this.ua)) && (screen.width < 1920)) {
			return true;
		}
		return false;
	},
	ckPSVita : function() {
		if ((/Vita/i.test(this.ua)) && (screen.width < 1920)) {
			return true;
		}
		return false;
	},
	ckPS4 : function() {
		if (/Playstation 4/i.test(this.ua)) {
			return true;
		}
		return false;
	},
	ckPSP : function() {
		if (/PSP/i.test(this.ua)) {
			return true;
		}
		return false;
	},
	ckTab : function() {
		//for this, we need to create an object on the page, apply css to it
		if (this.isTouchDevice() && ((screen.width > 481) && (screen.width < 1025))) {
			return true;
		}
		return false;

		/*if($("#sc_tab_chk").css('height') == "1px"){
		 return true;
		 }
		 return false;*/
	},
	ckPC : function() {
		return true;
	},
	ckMob : function() {
		var a = navigator.userAgent || navigator.vendor || window.opera;
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
			return true;
		} else {
			return false;
		};
	},
	getUserState : function() {
		var i = this;
		if (i.userState === null) {
			//we have a look for the userMenu
			i.userState = "guest";
			if ($("#logged-in-user").length) {
				//we are logged in
				i.userState = "signed_in";
			}
		}
		return i.userState;
	},
	getUserName : function() {
		var i = this;
		if (i.getUserState() == "signed_in") {
			return LITHIUM.CommunityJsonObject.User.login;
		}
		return "";
	},
	lookupIdFromShortTitle : function(shortTitle) {
		var cN = this.getCoreNode();
		var ancestors = cN.ancestors;
		var a_length = ancestors.length;
		if (cN.shortTitle == shortTitle) {
			return cN.id;
		}
		for (var j = 0; j < a_length; j++) {
			if (ancestors[j].shortTitle == shortTitle) {
				return ancestors[j].id;
			}
		}
		return shortTitle;
	},
	getQueryString : function() {
		if (typeof (this.queryString) == "undefined") {
			this.queryString = {};
			var hash;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			var h_l = hashes.length;
			for (var i = 0; i < h_l; i++) {
				hash = hashes[i].split('=');
				this.queryString[hash[0]] = hash[1];

			}
		}

		return this.queryString;
	}
};

eM.pageTypes = ["community", "category", "sub_category", "board", "thread", "tkb"];

